export const ACCOUNT = 'https://accountserver.lessonplan.cn';
export const CLIENT_ACCOUNT = 'https://clientaccountserver.lessonplan.cn';
export const PASSPORT_CLIENT = 'https://clientpassport.lessonplan.cn';
export const TEAMURL = 'https://templateserver.lessonplan.cn';
export const TSINGHUA_API = 'https://tsinghuashowserver.lessonplan.cn';
export const lessonplay_data = "https://lessonplaydata.lessonplan.cn/unifydata"